<template>
  <v-flex mb-0 xs12 mx-2>
    <v-layout row justify-start mx-3 mt-3 align-center>
      <div class="text-xs-left" style="font-sze: 20px; font-weight: 600;">Long Distance Service Info</div>
    </v-layout>

    <v-form v-model="valid" @submit="editLdService" ref="editLdServiceForm">
      <v-layout grid-list-md justify-start pa-0 ma-0 mr-0 pr-0 mt-2>
        <v-layout hide-details justify-start row mt-0 mb-2>
          <!-- Left Column of Fields -->
          <v-flex hide-details mx-4 xs4>
            <v-text-field
              style="max-height: 45px"
              v-model="service.WTN"
              value="WTN"
              label="Working Telephone #*"
              mask="(###) ###-####"
              required
              :rules="identifierRules"
            ></v-text-field>
            <v-text-field
              style="max-height: 45px"
              v-model="service.BTN"
              value="WTN"
              label="Billing Telephone #"
              mask="(###) ###-####"
              :rules="btnRules"
            ></v-text-field>
            <v-autocomplete
              hide-details
              :items="ddlAccountCodes"
              v-model="service.AccountCodes"
              item-text="Text"
              item-value="Value"
              label="Account Codes"
              required
              :rules="requiredRules"
            ></v-autocomplete>
            <v-text-field
              style="max-height: 45px"
              v-model="service.LengthListId"
              value="LengthListId"
              label="Length / List ID"
            ></v-text-field>
          </v-flex>
          <!-- Center Column of Fields -->
          <v-flex hide-details mx-4 xs4>
            <v-autocomplete
              hide-details
              :items="ddlInvoiceDetail"
              v-model="service.InvoiceDetail"
              item-text="Text"
              item-value="Value"
              label="Invoice Detail*"
              clearable
              required
              :rules="requiredRules"
            ></v-autocomplete>
            <v-autocomplete
              hide-details
              :items="ddlInterRate"
              v-model="service.InterRate"
              item-text="Text"
              item-value="Value"
              label="Inter Rate*"
              clearable
              required
              :rules="requiredRules"
            ></v-autocomplete>
            <v-autocomplete
              hide-details
              :items="ddlIntraRate"
              v-model="service.IntraRate"
              item-text="Text"
              item-value="Value"
              label="Intra Rate*"
              clearable
              required
              :rules="requiredRules"
            ></v-autocomplete>
            <v-autocomplete
              hide-details
              :items="ddlIntlRate"
              v-model="service.IntlRate"
              item-text="Text"
              item-value="Value"
              label="Intl Rate*"
              clearable
              required
              :rules="requiredRules"
            ></v-autocomplete>
          </v-flex>
          <!-- Right Column of Fields -->
          <v-flex hide-details mx-4 xs4>
            <v-text-field
              style="max-height: 45px"
              v-model="service.BillPrintText"
              value="BillPrintText"
              label="Bill Print Text"
              maxlength="25"
            ></v-text-field>
            <v-text-field
              style="max-height: 45px"
              v-model="service.OrderNumber"
              value="OrderNumber"
              label="LOA #*"
              required
              maxlength="20"
              :rules="requiredRules"
            ></v-text-field>
            <v-menu
              v-model="menu"
              :close-on-content-click="true"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                style="max-height: 44px"
                slot="activator"
                v-model="service.OrderDate"
                label="LOA Date*"
                prepend-inner-icon="fa-calendar-alt"
                readonly
                clearable
                required
                :rules="requiredRules"
              ></v-text-field>
              <v-date-picker v-model="service.OrderDate" @input="menu = false"></v-date-picker>
            </v-menu>
            <v-autocomplete
              hide-details
              :items="ddlLocationTypes"
              v-model="service.LocationType"
              value="LocationType"
              label="Location Type*"
              required
              :rules="requiredRules"
              item-text="Text"
              item-value="Value"
            ></v-autocomplete>
            <v-autocomplete
              hide-details
              :items="ddlSalesIds"
              v-model="service.SalesId"
              value="SalesId"
              label="Sales ID*"
              required
              :rules="requiredRules"
              item-text="Text" 
              item-value="Value"
            ></v-autocomplete>
            <v-autocomplete
              style="margin-top: 50px;"
              hide-details
              :items="ddlActionRequest"
              v-model="service.ActionRequest"
              item-text="Text"
              item-value="Value"
              clearable
              required
              :rules="requiredRules"
            >
              <template slot="label">
                <div class="red--text">Service Action*</div>
              </template>
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </v-layout>
      <v-layout row hide-details justify-start ml-4 mt-0 mb-0>
        <v-checkbox
          label="Use Service Point Address?"
          v-model="showSPAddress"
        ></v-checkbox>
      </v-layout>
      <v-layout row hide-details justify-start mt-0 mb-4 v-if="showSPAddress">
        <servicePointAddress v-if="showSPAddress" ref="componentSPAddress" :ServicePointAddress="service.ServicePointAddress ? service.ServicePointAddress : {}"></servicePointAddress>
      </v-layout>
      <v-layout hide-details justify-end row mt-0 mb-4>
        <v-btn color="success" @click="editLdService()" class="ml-2 mr-4">Edit</v-btn>
      </v-layout>
    </v-form>
  </v-flex>
</template>

<script>
import axios from "axios";
import Bus from "../../bus";
import servicePointAddress from "./ServicePointAddress.vue";

export default {
  name: "Edit1PlusService",
  props: [
    "accountNumber",
    "elementType",
    "elementDescription",
    "serviceType",
    "providerId",
    "serviceId"
  ],
  components: {
    servicePointAddress
  },
  async mounted() {
    // Populate Sales Ids DDL
    axios
     // Populate Invoice Detail DDL
    axios
      .get("/api/Services/GetInvoiceDetailLevelDDLs/LDSW")
      .then(response => {
        this.ddlInvoiceDetail = response.data;
        if (this.ddlInvoiceDetail.length === 1) {
          this.service.InvoiceDetail = this.ddlInvoiceDetail[0].Value;
        }
      })
      .catch(error => {
        console.log(error);
      });
    // Populate Inter Rate DDL
    axios
      .get("/api/Services/GetRatePlansDDL/LDSW/IE")
      .then(response => {
        this.ddlInterRate = response.data;
      })
      .catch(error => {
        console.log(error);
      });
    // Populate Intra Rate DDL
    axios
      .get("/api/Services/GetRatePlansDDL/LDSW/IA")
      .then(response => {
        this.ddlIntraRate = response.data;
      })
      .catch(error => {
        console.log(error);
      });
    // Populate Intl Rate DDL
    axios
      .get("/api/Services/GetRatePlansDDL/LDSW/IT")
      .then(response => {
        this.ddlIntlRate = response.data;
      })
      .catch(error => {
        console.log(error);
      });
    // Populate Sales Ids DDL
    axios
      .get("/api/Services/GetSalesIdDDL")
      .then(response => {
        this.ddlSalesIds = response.data;
        if (this.ddlSalesIds.length === 1) {
          this.service.SalesId = this.ddlSalesIds[0].Value;
        }
      })
      .catch(error => {
        console.log(error);
      });
    var GetEditServiceInfo = await axios
      .get("api/Services/GetEditServiceInfo/" + this.serviceId)
      .then(async res =>{
        this.service = await res.data;
        this.ddlActionRequest = await res.data.ddlActionRequest;
        if (this.service.LOADate) {
          this.service.LOADate = this.service.LOADate.split("T")[0];
        }
        
        if (this.service.InvoiceDetail) {
          this.service.InvoiceDetail = this.service.InvoiceDetail.toString()
        }
        this.service.AccountCodes = this.service.AccountCodes.toString()
        
        this.service.ActionRequest = "ZZ";
      });
      if (this.service.ServicePointAddress){
          this.showSPAddress = true
        }
  },

  data() {
    return {
      service: {},
      valid: true,
      menu: false,
      showSPAddress:false,

      // Drop down list variables
     ddlInvoiceDetail: [],
      ddlSalesIds: [],
      ddlAccountCodes: [
        {
          Text: "None",
          Value: "0"
        },
        {
          Text: "Unverified",
          Value: "1"
        },
        {
          Text: "Verified",
          Value: "2"
        }
      ],
      ddlInterRate: [],
      ddlIntraRate: [],
      ddlIntlRate: [],
      ddlLocationTypes: [
        {
          Text: "Business",
          Value: "B"
        },
        {
          Text: "Residence",
          Value: "R"
        }
      ],
      ddlActionRequest:[],

      // Form validation Rules
      identifierRules: [
        v => !!v || "",
        v =>
          /^[1-9][0-9]{9}$/.test(v) || "Working Telephone # must be 10 digits"
      ],
      btnRules: [
        v => {
          if (v){
            return /^([1-9][0-9]{9})?$/.test(v) ||
          "Billing Telephone # must be 10 digits"
          }else{
            return true
          }
        }
      ],
      requiredRules: [v => !!v || ""]
    };
  },

  methods: {
    async editLdService() {
      if (this.$refs.editLdServiceForm.validate()) {
        if (this.showSPAddress) {
          this.service.ServicePointAddress = await this.$refs.componentSPAddress
            .servicePointAddress;
        }else{
          if (this.service.ServicePointAddress){
            delete this.service.ServicePointAddress
          }
        } 
        axios
          .post("/api/Services/Edit1PlusService", this.service)
          .then(res => {
            console.log(res);
            Bus.$emit("alert", {
              color: "success",
              message: "Service Edited Successfully!"
            });
            this.$emit("close");
          })
          .catch(err => {
            console.log(err);

            Bus.$emit("alert", {
              color: "error",
              message: "An Error Occured while Editing Service."
            });
          });
      }
    },
//     isEmpty(obj) {
//     for(var key in obj) {
//         if(obj.hasOwnProperty(key))
//             return false;
//     }
//     return true;
// }
  }
};
</script>